import React from 'react';

import CmsActivitiesRouter from '../containers/CmsActivitiesRouter';

const CmsActivitiesAppClient = (props) => (
  <CmsActivitiesRouter {...props} />
);

export default CmsActivitiesAppClient;
